import { render } from "./addhotel.vue?vue&type=template&id=701ea6fa&scoped=true"
import script from "./addhotel.vue?vue&type=script&lang=js"
export * from "./addhotel.vue?vue&type=script&lang=js"

import "./addhotel.vue?vue&type=style&index=0&id=701ea6fa&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-701ea6fa"

export default script